import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "palliative-codes-visits-table",
  templateUrl: "palliative-codes-visits-table.html",
})
export class PalliativeCodesVisitsTable implements OnInit, OnDestroy {
  @Input() palliativeVisitCodes: any[];
  @Output() onRateChanged = new EventEmitter<any>();
  @Input() rates: boolean = false;

  ngOnDestroy(): void {}

  ngOnInit(): void {}

  constructor() {}

  codeChanged(visitCode, i) {
    this.palliativeVisitCodes[i].Error = this.checkValidModifiers(visitCode);
    this.onRateChanged.emit(this.palliativeVisitCodes);
  }

  alphanumericOnlyValidation(event: any) {
    const pattern = /[a-zA-Z0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  checkValidModifiers(visitCode) {
    if (
      (visitCode.M1 && visitCode.M1.length == 1) ||
      (visitCode.M2 && visitCode.M2.length == 1) ||
      (visitCode.M3 && visitCode.M3.length == 1) ||
      (visitCode.M4 && visitCode.M4.length == 1)
    )
      return "lengthError";

    if (visitCode.M4 && visitCode.M4.length > 0) {
      return visitCode.M3 &&
        visitCode.M3.length > 0 &&
        visitCode.M2 &&
        visitCode.M2.length > 0 &&
        visitCode.M1 &&
        visitCode.M1.length > 0
        ? ""
        : "orderError";
    } else if (visitCode.M3 && visitCode.M3.length > 0) {
      return visitCode.M2 &&
        visitCode.M2.length > 0 &&
        visitCode.M1 &&
        visitCode.M1.length > 0
        ? ""
        : "orderError";
    } else if (visitCode.M2 && visitCode.M2.length > 0) {
      return visitCode.M1 && visitCode.M1.length > 0 ? "" : "orderError";
    }

    return "";
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/billing-codes/palliative-visits/palliative-codes-visits-table/palliative-codes-visits-table.ts